// Isso é necessário pq:
// - o frontend usa código do BFF
// - o código utilizado tem uma cadeia de imports que acaba importando a lib @elastic/elasticsearch
// - a lib @elastic/elasticsearch só funciona em NodeJS
// - como o frontend não executa em NodeJS, a ausência deste gera erro na lib @elastic/elasticsearch
if (!process.versions?.node) process.versions.node = '0.0.0'
if (!process.emitWarning) process.emitWarning = () => {}
export {}
